export default function initMobileMenu() {
  const btnsMenu = document.querySelectorAll('.btn-menu');

  btnsMenu.forEach(btnMenu => {
    const body = document.querySelector('body');
    const btnsMenuClose = document.querySelector('.btn-menu-close');
    const openedClass = 'menu-opened';
    
    const openCloseMenu = (e) => {
      e.preventDefault();
      
      body.classList.toggle(openedClass)
    }
    
    btnMenu.addEventListener('click', openCloseMenu);
    btnsMenuClose.addEventListener('click', openCloseMenu);
  })
}
